import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { Link, navigate } from "@reach/router";
import LearnStepper from "./LearnStepper";
import { Step1, Step2, Step3, Step4, Step5, NotFoundStep } from "./stepcontent";

const useStyles = makeStyles(theme => ({
  grid: {
    flexGrow: 1
  },
  stepperBar: {
    marginTop: theme.spacing(2)
  },
  divider: {
    width: "100%",
    height: 1
  }
}));
function getSteps() {
  return ["实验前言", "构件认知学习", "实景学习", "虚拟搭建实验", "资源库建设"];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return Step1;
    case 1:
      return Step2;
    case 2:
      return Step3;
    case 3:
      return Step4;
    case 4:
      return Step5;
    default:
      return NotFoundStep;
  }
}

function LearnPage(props) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(Number(props.stepId) - 1);
  useEffect(() => {
    setActiveStep(Number(props.stepId) - 1);
  }, [props.stepId]);

  const StepNow = getStepContent(activeStep);
  return (
    <>
      <Grid container className={classes.grid} spacing={1}>
        <Grid item xs={12} className={classes.stepperBar}>
          <LearnStepper activeStep={activeStep} getSteps={getSteps} />
        </Grid>
        <Divider className={classes.divider} />
        <Grid item xs={12}>
          <StepNow />
        </Grid>
      </Grid>
    </>
  );
}

export default LearnPage;
